"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getCurrentItem_1 = __importDefault(require("./getCurrentItem"));
/**
 * Return the previous item, from current selection or from a node.
 */
var getPreviousItem = function (opts) { return function (value, block) {
    var document = value.document, startBlock = value.startBlock;
    block = block || startBlock;
    var currentItem = getCurrentItem_1.default(opts)(value, block);
    if (!currentItem) {
        return null;
    }
    var previousSibling = document.getPreviousSibling(currentItem.key);
    if (!previousSibling) {
        return null;
    }
    else if (previousSibling.type === opts.typeItem) {
        return previousSibling;
    }
    return null;
}; };
exports.default = getPreviousItem;
//# sourceMappingURL=getPreviousItem.js.map